import { render, staticRenderFns } from "./iDalgo-Liveblog.vue?vue&type=template&id=85624402"
import script from "./iDalgo-Liveblog.vue?vue&type=script&lang=js"
export * from "./iDalgo-Liveblog.vue?vue&type=script&lang=js"
import style0 from "./iDalgo-Liveblog.vue?vue&type=style&index=0&id=85624402&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports